export const checkFilterDropdownValue = (filter) => {
	if (!filter[0]?.value) {
		return "";
	}
	if (filter[0]?.value?.toLowerCase() == "semua") {
		return "";
	}
	return filter[0]?.value;
}
